package org.multiplatform.kotfolio.di

import org.koin.dsl.module

fun appModule() = module {
    includes(
        gatewayModule
    )
}
